import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import bankAccountsService from "../services/bankAccountsService";
import "../assets/bankAccountEdit.css";

const BankAccountEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [formData, setFormData] = useState({
    name: "",
    default_for_clients: false,
  });
  const [loading, setLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState("");

  // Load bank account data on component mount
  useEffect(() => {
    loadBankAccount();
  }, [id]);

  const loadBankAccount = async () => {
    try {
      setLoading(true);
      setError("");
      console.log(`Loading bank account ${id} for editing...`);

      const response = await bankAccountsService.getBankAccount(id);

      if (response.success && response.data) {
        setFormData({
          name: response.data.name || "",
          default_for_clients: response.data.default_for_clients || false,
        });
        console.log("Bank account loaded for editing:", response.data);
      } else {
        throw new Error(response.message || "Failed to load bank account");
      }
    } catch (err) {
      console.error("Error loading bank account:", err);
      setError(err.message || "Failed to load bank account");
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
    setError(""); // Clear error when user types
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name.trim()) {
      setError("Bank account name is required");
      return;
    }

    try {
      setIsSubmitting(true);
      setError("");

      console.log(`Updating bank account ${id}:`, formData);
      const response = await bankAccountsService.updateBankAccount(
        id,
        formData
      );

      if (response.success) {
        console.log("Bank account updated successfully:", response.data);
        navigate("/bank-accounts");
      } else {
        throw new Error(response.message || "Failed to update bank account");
      }
    } catch (err) {
      console.error("Error updating bank account:", err);
      setError(err.message || "Failed to update bank account");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    navigate("/bank-accounts");
  };

  if (loading) {
    return (
      <div className="bank-account-edit-container">
        <div className="container-fluid">
          <div className="panel panel-default panel-standard">
            <div className="panel-body text-center">
              <p>Loading bank account...</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bank-account-edit-container">
      <div className="container-fluid">
        {/* Breadcrumb Navigation */}
        <nav className="breadcrumb">
          <span onClick={() => navigate('/dashboard')} className="breadcrumb-item" style={{ cursor: 'pointer', color: '#337ab7' }}>
            Dashboard
          </span>
          <span className="breadcrumb-separator">/</span>
          <span onClick={() => navigate('/bank-accounts')} className="breadcrumb-item" style={{ cursor: 'pointer', color: '#337ab7' }}>
            GG Bank Accounts
          </span>
          <span className="breadcrumb-separator">/</span>
          <span className="breadcrumb-item active">Edit Bank Account</span>
        </nav>

        {/* Main Panel */}
        <div className="panel panel-default panel-standard">
          <div className="panel-heading">
            <h3 className="panel-title">Edit GG Bank Accounts</h3>
          </div>
          <div className="panel-body">
            {error && <div className="alert alert-danger">{error}</div>}

            <form onSubmit={handleSubmit} className="form-horizontal">
              <div className="form-group">
                <label htmlFor="name" className="col-sm-2 control-label">
                  Name <span className="required">*</span>
                </label>
                <div className="col-sm-10">
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    className="form-control"
                    placeholder="Enter bank account name"
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <div className="col-sm-offset-2 col-sm-10">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      name="default_for_clients"
                      checked={formData.default_for_clients}
                      onChange={handleInputChange}
                    />{" "}
                    Default for clients
                  </label>
                </div>
              </div>

              <div className="form-group">
                <div className="col-sm-offset-2 col-sm-10">
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Saving..." : "Save"}
                  </button>
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={handleCancel}
                    style={{ marginLeft: "10px" }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BankAccountEdit;
